import api from "@/lib/api";

export async function monitoringFases(unidade, setor, filterFases) {
  const { data } = await api.get("/secretaria-digital/monitoring/fases", { params: { unidade, setor, filterFases } })
  return data
}